var map = {
	"./513906855_17843153880530050_5745062199497274673_n.jpg": 44,
	"./avatar-1.jpg": 45,
	"./avatar-2.jpg": 46,
	"./avatar-3.jpg": 47,
	"./avatar-4.jpg": 48,
	"./avatar.jpg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;